export default function Settings() {
  return <div>{/* <h1>Manage main page</h1> */}</div>;
}
